import * as yup from 'yup'

// Messages are translation keys; LabelledInput passes them through t().

const helpSchema = yup.object().shape({
  email: yup
    .string()
    .email('validation.emailRequired')
    .required('validation.emailRequired'),
  name: yup.string().required('validation.nameRequired'),
  ticket: yup
    .string()
    .required('validation.helpTicketRequired'),
})

export default helpSchema